import { create } from '../../utils/create';
import { isEqual } from '../../utils/objects';
import { CartList } from '../../components/CartList/CartList';
import { Total } from '../../components/CartTotal/CartTotal';
export class PageCart {
    constructor(parent, model, controller, header) {
        this.createDefaultLayer = () => {
            this.section = create({
                tagName: 'section',
                classNames: 'cart container cart__wrapper',
                parent: this.parent
            });
        };
        this.unmount = () => {
            var _a;
            if (this.subsIndex !== null) {
                this.model.unsubscribe(this.subsIndex);
            }
            (_a = this.section) === null || _a === void 0 ? void 0 : _a.remove();
        };
        this.mount = (props) => {
            var _a;
            if (this.header.searchWrapper !== null) {
                this.header.searchWrapper.style.visibility = 'hidden';
            }
            this.createDefaultLayer();
            if (this.controller.getCurrentCartProducts().length !== 0) {
                this.subsIndex = this.model.subscribe((state, prevState) => {
                    var _a;
                    if (localStorage.length === 0) {
                        if (isEqual(state.cartProducts, prevState === null || prevState === void 0 ? void 0 : prevState.cartProducts)) {
                            return;
                        }
                    }
                    (_a = this.section) === null || _a === void 0 ? void 0 : _a.remove();
                    this.header.renderCartWrapper();
                    this.createDefaultLayer();
                    const total = new Total(this.section, this.controller);
                    const cartList = new CartList(this.section, this.controller, total, this.header, this);
                    cartList.update();
                    total.update();
                });
            }
            else {
                (_a = this.section) === null || _a === void 0 ? void 0 : _a.appendChild(create({
                    tagName: 'h1',
                    classNames: 'no-items',
                    children: `Your shopping cart is empty :(`
                }));
            }
            (props === null || props === void 0 ? void 0 : props.mounted) && (props === null || props === void 0 ? void 0 : props.mounted());
        };
        this.parent = parent;
        this.section = null;
        this.model = model;
        this.mounted = false;
        this.controller = controller;
        this.header = header;
        this.subsIndex = null;
    }
}
